import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import PasswordInput, { isPasswordValid } from '../components/PasswordInput';
import api from '../api';

export default function ResetPassword() {
  const [params]      = useSearchParams();
  const navigate      = useNavigate();
  const token         = params.get('token');

  const [valid,    setValid]    = useState(null); // null=loading, true, false
  const [email,    setEmail]    = useState('');
  const [pw,       setPw]       = useState('');
  const [pw2,      setPw2]      = useState('');
  const [loading,  setLoading]  = useState(false);
  const [done,     setDone]     = useState(false);
  const [error,    setError]    = useState('');

  useEffect(() => {
    if (!token) { setValid(false); return; }
    api.get(`/auth/reset-password/validate?token=${token}`)
      .then(r => { setValid(true); setEmail(r.data.email); })
      .catch(() => setValid(false));
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (pw !== pw2) { setError('Slaptažodžiai nesutampa'); return; }
    if (!isPasswordValid(pw)) { setError('Slaptažodis neatitinka reikalavimų'); return; }
    setLoading(true); setError('');
    try {
      await api.post('/auth/reset-password', { token, newPassword: pw });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Klaida. Bandykite iš naujo.');
    } finally { setLoading(false); }
  }

  // Loading
  if (valid === null) return (
    <div className="login-page">
      <div className="login-card" style={{ textAlign: 'center' }}>
        <span className="loading-spinner" style={{ width: 32, height: 32 }} />
        <p style={{ marginTop: 16, color: 'var(--text-muted)' }}>Tikrinama nuoroda...</p>
      </div>
    </div>
  );

  // Invalid token
  if (!valid) return (
    <div className="login-page">
      <div className="login-card" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⛔</div>
        <div className="login-title">Nuoroda nebegalioja</div>
        <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
          Atstatymo nuoroda yra neteisinga arba pasibaigė jos galiojimo laikas (1 val.).
        </p>
        <Link to="/forgot-password" className="btn btn-primary" style={{ display: 'inline-flex', justifyContent: 'center' }}>
          Gauti naują nuorodą
        </Link>
      </div>
    </div>
  );

  // Success
  if (done) return (
    <div className="login-page">
      <div className="login-card" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
        <div className="login-title">Slaptažodis pakeistas!</div>
        <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
          Slaptažodis sėkmingai atnaujintas. Nukreipiame į prisijungimo puslapį...
        </p>
        <Link to="/login" className="btn btn-primary" style={{ display: 'inline-flex', justifyContent: 'center' }}>
          Prisijungti dabar
        </Link>
      </div>
    </div>
  );

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">🔑</div>
        <div className="login-title">Naujas slaptažodis</div>
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', marginBottom: 24, fontSize: 14 }}>
          Paskyra: <strong style={{ color: 'var(--text)' }}>{email}</strong>
        </p>

        {error && <div className="alert alert-error" style={{ marginBottom: 16 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <PasswordInput label="Naujas slaptažodis" value={pw} autoFocus
              onChange={e => setPw(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label">Pakartoti slaptažodį</label>
            <input className="form-input" type="password" value={pw2}
              onChange={e => setPw2(e.target.value)} required
              placeholder="Įveskite slaptažodį dar kartą" />
          </div>

          {pw && pw2 && pw !== pw2 && (
            <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 8, marginTop: -8 }}>
              ⚠️ Slaptažodžiai nesutampa
            </div>
          )}

          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
            {loading ? <span className="loading-spinner" /> : '✅ Nustatyti naują slaptažodį'}
          </button>
        </form>
      </div>
    </div>
  );
}
